import {
    HOUSING_INSURANCE_PRICE_TIER_2,
    HOUSING_INSURANCE_PRICE_TIER_1,
    ASSETS_INSURANCE_PRICE_TIER_1,
    MONTHLY_MIN_PRIME_PRICE,
} from "../../constants/prices";
import { isZero, round } from "./number";

export const getTierForHousingValue = housingValue => {
    if (housingValue <= HOUSING_INSURANCE_PRICE_TIER_1) {
        return 1;
    } else if (
        housingValue > HOUSING_INSURANCE_PRICE_TIER_1 &&
        housingValue < HOUSING_INSURANCE_PRICE_TIER_2
    ) {
        return 2;
    }
    return 3;
};

export const getTierForAssetsValue = assetsValue => {
    if (assetsValue < ASSETS_INSURANCE_PRICE_TIER_1) {
        return 1;
    }
    return 2;
};

export const getMonthlyPrice = amount => {
    const HOME_PRIME_VALUE = 0.735948;
    const COMMERCIAL_FEE = 1.03;
    const IGV = 1.18;
    const MONTHS_YEAR = 12;

    if (isZero(amount)) {
        return amount;
    }

    const result = round((amount * HOME_PRIME_VALUE) / 1000);
    const resultCommercial = round(result * COMMERCIAL_FEE);
    const resultTotal = round(resultCommercial * IGV);

    const monthlyPrice = resultTotal / MONTHS_YEAR;

    return monthlyPrice > MONTHLY_MIN_PRIME_PRICE
        ? monthlyPrice
        : MONTHLY_MIN_PRIME_PRICE;
};
